import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";

import {
    Button,
    Card,
    CardBody,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Form,
    FormFeedback,
    Input,
    Label,
    Row,
    Table,
    UncontrolledDropdown,
    UncontrolledTooltip
} from "reactstrap";

import { isPermission, uId } from "common/utility";
import ToastDialog from "components/Common/ToastDialog";
import { addUser, editUser, getUser } from "http/fundLync/user.helper";
import { getRoleByEntityType } from "../../http/fundLync/role.helper"


const PartnerAddressDetails = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isAddAddressOpen, setAddAddressOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [userList, setUserList] = useState([]);
    const urlParams = new URLSearchParams(window.location.search);
    const encodedId = urlParams.get("id");
    const entityId = atob(encodedId);
    const [userEditData, setUserEditData] = useState([]);
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [isNewUserPermission, setNewUserPermission] = useState(false)
    const [isRoleList, setRoleListPermission] = useState(false)
    const [roleList, setRoleList] = useState([])

    // validation
    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            firstName: userEditData && userEditData[0]?.firstName || "",
            lastName: userEditData && userEditData[0]?.lastName || "",
            email: userEditData && userEditData[0]?.email || "",
            mobileNo: userEditData && userEditData[0]?.mobileNo || "",
            id: userEditData && userEditData[0]?.id || "",
            roleId: userEditData && userEditData[0]?.roleId || "",
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required("Please Enter First Name"),
            lastName: Yup.string().required("Please Enter Last Name"),
            email: Yup.string().required("Please email"),
            mobileNo: Yup.string()
                .required("Please Mobile Number")
                .matches(/^\d{10}$/, "Mobile Number must be exactly 10 digits"),
            roleId: isRoleList
                ? Yup.string().required("Please Select Role Type")
                : Yup.string(),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                const entity = {
                    id: values.id,
                    firstName: values.firstName,
                    lastName: values.lastName,
                    email: values.email,
                    mobileNo: String(values.mobileNo),
                    entityId,
                };
                if (isRoleList) {
                    entity.roleId = values.roleId
                } else {
                    entity.roleId = 2
                }
                editUser(entity)
                    .then((response) => {
                        if (response.code == 201 && response.status) {
                            validation.resetForm()
                            setToastInfo({
                                message: "User Saved",
                                showToast: true,
                                role: "success",
                            })
                            getUser({ entityId })
                                .then((response) => {
                                    if (response.code == 200 && response.status) {
                                        setUserList(response?.data?.data)
                                    }
                                }).catch((error) => {
                                    console.log(error)
                                })
                            setAddAddressOpen(false);
                        } else {
                            const { message } = response;
                            setToastInfo({
                                message: message,
                                showToast: true,
                                role: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else {
                const entity = {
                    firstName: values.firstName,
                    lastName: values.lastName,
                    email: values.email,
                    mobileNo: String(values.mobileNo),
                    entityId,
                };
                if (isRoleList) {
                    entity.roleId = values.roleId
                } else {
                    entity.roleId = 2
                }
                addUser(entity)
                    .then((response) => {
                        if (response.status) {
                            validation.resetForm()
                            setToastInfo({
                                message: "User Saved",
                                showToast: true,
                                role: "success",
                            })
                            getUser({ entityId })
                                .then((response) => {
                                    if (response.code == 200 && response.status) {
                                        setUserList(response?.data?.data)
                                    }
                                }).catch((error) => {
                                    console.log(error)
                                })
                            setAddAddressOpen(false);
                        } else {
                            const { message } = response;
                            setToastInfo({
                                message: message,
                                showToast: true,
                                role: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }

        },
    });

    useEffect(() => {
        getUser({ entityId })
            .then((response) => {
                if (response.code == 200 && response.status) {
                    setUserList(response?.data?.data)
                }
            })
            .catch((error) => {
                console.log(error)
            })
        checkPermissions()
    }, []);

    const checkPermissions = async () => {

        const isNewUserpermission = await isPermission("authorised_person", "create_permission")
        const isRoleListPermission = await isPermission("roles", "list_permission")
        setRoleListPermission(isRoleListPermission)
        setNewUserPermission(isNewUserpermission)
        if (isRoleListPermission) {
            getRoleByEntityType({ searchKey: 'Partner' })
                .then((response) => {
                    if (response.status) {
                        setRoleList(response.data.data)
                    }
                })
                .catch((error) => {

                });
        }
    }

    const handleCustomerClicks = () => {
        setAddAddressOpen(true);
        setIsEdit(false);
        setUserEditData(null);
    };

    const handleCancelrClicks = () => {
        setAddAddressOpen(false);
        setUserEditData(null);
    };

    const EditAddress = (id) => {
        setIsEdit(true);
        const filteredData = userList.filter((elem) => {
            return elem.id == id;
        });
        setUserEditData(filteredData);
        setAddAddressOpen(true);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
        setAddAddressOpen(false);
        setIsEdit(false);
    };

    return (
        <div>
            <div>
                <Card style={{ padding: "10px" }}>
                    <div
                        className="d-flex justify-content-between mt-1"
                        style={{ cursor: "pointer" }}
                        onClick={toggleDropdown}
                    >
                        <div>
                            <h5>User</h5>
                        </div>
                        <div className="me-2">
                            <i
                                className={`fas fa-angle-${isDropdownOpen ? "up" : "down"}`}
                                style={{ fontSize: "20px" }}
                            ></i>
                        </div>
                    </div>
                    {isAddAddressOpen && (
                        <Card>
                            <CardBody>
                                <Form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        validation.handleSubmit();
                                        return false;
                                    }}
                                >
                                    <div>
                                        <h4 style={{ marginTop: "1%" }}> User Details</h4>
                                    </div>

                                    <Row className="mb-3">

                                        <Col sm="12" md="6">
                                            <Label className="form-label mt-4">First Name*</Label>
                                            <Input
                                                name="firstName"
                                                type="text"
                                                placeholder="Insert First Name"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.firstName || ""}
                                                invalid={
                                                    validation.touched.firstName &&
                                                    validation.errors.firstName
                                                }
                                            />
                                            {validation.touched.firstName &&
                                                validation.errors.firstName ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.firstName}
                                                </FormFeedback>
                                            ) : null}
                                        </Col>

                                        <Col sm="12" md="6">
                                            <Label className="form-label mt-4">Last Name*</Label>
                                            <Input
                                                name="lastName"
                                                type="text"
                                                placeholder="Insert Last Name"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.lastName || ""}
                                                invalid={
                                                    validation.touched.lastName &&
                                                    validation.errors.lastName
                                                }
                                            />
                                            {validation.touched.lastName &&
                                                validation.errors.lastName ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.lastName}
                                                </FormFeedback>
                                            ) : null}
                                        </Col>

                                        <Col sm="12" md="6">
                                            <Label className="form-label mt-4">Email*</Label>
                                            <Input
                                                name="email"
                                                type="email"
                                                placeholder="Insert Email"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.email || ""}
                                                invalid={
                                                    validation.touched.email && validation.errors.email
                                                }
                                            />
                                            {validation.touched.email && validation.errors.email ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.email}
                                                </FormFeedback>
                                            ) : null}
                                        </Col>

                                        <Col sm="12" md="6">
                                            <Label className="form-label mt-4">Mobile No.*</Label>
                                            <Input
                                                name="mobileNo"
                                                type="text"
                                                placeholder="Insert Mobile No"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.mobileNo || ""}
                                                invalid={
                                                    validation.touched.mobileNo &&
                                                    validation.errors.mobileNo
                                                }
                                            />
                                            {validation.touched.mobileNo &&
                                                validation.errors.mobileNo ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.mobileNo}
                                                </FormFeedback>
                                            ) : null}
                                        </Col>

                                        {isRoleList && (
                                            <Col sm="12" md="6">
                                                <Label className="form-label mt-4">Role Type*</Label>
                                                <Input
                                                    name="roleId"
                                                    type="select"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.roleId || ""}
                                                    invalid={validation.touched.roleId && validation.errors.roleId}
                                                >
                                                    <option value="" disabled>Select Role Type</option>
                                                    {roleList.map((option) => (
                                                        <option key={option.id} value={option.id}>
                                                            {option.displayName}
                                                        </option>
                                                    ))}
                                                </Input>
                                                {validation.touched.roleId && validation.errors.roleId ? (
                                                    <FormFeedback type="invalid">{validation.errors.roleId}</FormFeedback>
                                                ) : null}
                                            </Col>
                                        )}

                                    </Row>

                                    <div className="mb-3 d-flex" style={{ width: "100%" }}>
                                    </div>

                                    <Row>
                                        <Col>
                                            <div className="text-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger save-customer me-2"
                                                    onClick={handleCancelrClicks}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-success save-customer"
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    )}
                    {isDropdownOpen && (
                        <Row>
                            <div className="text-sm-end">
                                {isNewUserPermission &&
                                    <Button
                                        type="button"
                                        color="success"
                                        className="btn-rounded mb-2 me-2"
                                        onClick={handleCustomerClicks}
                                    >
                                        <i className="mdi mdi-plus me-1" />
                                        New User
                                    </Button>
                                }
                            </div>
                            <Col xs="12">
                                <div className="table-responsive">
                                    <Table className="table table-bordered mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Id</th>
                                                <th>First Name</th>
                                                <th>Last Name</th>
                                                <th>Email</th>
                                                <th>Mobile</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userList.length == 0 ?
                                                <tr>
                                                    <td colSpan={6} className="text-center">No data found</td>
                                                </tr> :
                                                (userList.map((elem, index) => (
                                                    <tr key={uId()}>
                                                        <td>{index + 1}</td>
                                                        <td>{elem.firstName || "-"}</td>
                                                        <td>{elem.lastName || "-"}</td>
                                                        <td>{elem.email}</td>
                                                        <td>{elem.mobileNo}</td>
                                                        <td>
                                                            <UncontrolledDropdown>
                                                                <DropdownToggle tag="a" className="card-drop">
                                                                    <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                                                </DropdownToggle>

                                                                <DropdownMenu className="dropdown-menu-end">
                                                                    <DropdownItem
                                                                        onClick={() => {
                                                                            EditAddress(elem.id);
                                                                        }}
                                                                    >
                                                                        <i
                                                                            className="mdi mdi-pencil font-size-16 text-success me-1"
                                                                            id="edittooltip"
                                                                        ></i>
                                                                        Edit
                                                                        <UncontrolledTooltip
                                                                            placement="top"
                                                                            target="edittooltip"
                                                                        >
                                                                            Edit
                                                                        </UncontrolledTooltip>
                                                                    </DropdownItem>
                                                                </DropdownMenu>
                                                            </UncontrolledDropdown>
                                                        </td>
                                                    </tr>
                                                )))}
                                        </tbody>
                                    </Table>
                                </div>
                            </Col>
                        </Row>
                    )}
                </Card>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
        </div>
    );
}

export default PartnerAddressDetails;
